import React, { PropsWithChildren } from 'react';
import { useDialog } from '../dialog.context';

type TriggerProps = {
  asChild?: boolean;
};

export const Trigger = ({
  children,
  asChild,
}: PropsWithChildren<TriggerProps>) => {
  const { openDialog } = useDialog();

  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, { onClick: openDialog });
  }

  return <button onClick={openDialog}>{children}</button>;
};

Trigger.displayName = 'Dialog.Trigger';
